import { RequestManager } from "./index";

const pwfURL = process.env.BIG_FLIP_BASE_PWF_URL;

const request = new RequestManager(pwfURL);

export default request;
